<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="detail-header">
          <span class="header-title">智能灌溉设备自动控制策略配置</span>
          <div class="arrow-pic"></div>
        </div>
        <el-divider></el-divider>
        <div class="config-header">
          <div class="config-header-title">将策略应用于以下组</div>
          <div class="config-content">
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                :key="item.id"
                v-for="item in groubTabs"
                :label="item.areaCode"
                disabled
                >{{ item.areaName }}</el-checkbox
              >
            </el-checkbox-group>
          </div>
        </div>

        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top: 0; overflow-y: auto">
        <div class="config-header">
          <div class="config-header-title">自动控制策略</div>
          <div class="config-content">
            <el-form ref="form" :model="autoControlConfig">
              <el-row
                v-for="(item, index) in autoControlConfig.irrigationTimeList"
                :key="index"
              >
                <el-col :span="10">
                  <el-form-item
                    label="打开时间"
                    :prop="'irrigationTimeList.' + index + '.openTime'"
                    :rules="{
                      required: true,
                      message: '请填写打开时间',
                      trigger: 'blur',
                    }"
                  >
                    <el-time-picker
                      v-model="item.openTime"
                      format="HH:mm"
                      value-format="HH:mm"
                      :disabled="isDisableControl"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="请设置喷灌时长（分钟）"
                    label-width="20rem"
                    :prop="'irrigationTimeList.' + index + '.openDuration'"
                    :rules="{
                      required: true,
                      message: '请设置喷灌时长',
                    }"
                  >
                    <el-input-number
                      v-model="item.openDuration"
                      :disabled="isDisableControl"
                      :min="1"
                    ></el-input-number>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item>
                    <el-button
                      size="small"
                      plain
                      @click="addRow(index)"
                      :disabled="isDisableControl"
                    >
                      新增自动控制时间</el-button
                    >
                    <el-button
                      class="button-danger"
                      v-if="
                        autoControlConfig.irrigationTimeList.length > 1 &&
                        index != 0
                      "
                      size="small"
                      @click="removeRow(index)"
                      :disabled="isDisableControl"
                    >
                      删除</el-button
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </zj-layout-main>
      <el-footer style="text-align: center">
        <el-button
          type="primary"
          @click="OnConfirm('form')"
          :disabled="isDisableControl"
          >确认</el-button
        >
        <el-button @click="OnCancel">取消</el-button>
      </el-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import {
  getEquipmentCode,
  listEquipment,
  listEquipmentArea,
} from "@/api/src/equipment";
import {
  listSprinklingIrrigationSetting,
  addSprinklingIrrigationSetting,
  updateSprinklingIrrigationSetting,
  batchUpdateSprinklingIrrigationSetting,
} from "@/api/src/sprinklingIrrigationSetting";

export default {
  name: "IrrigationControlConfig",
  controller: "UI",
  action: "IrrigationControlConfig",

  data() {
    return {
      groubTabs: [{ areaName: "全部", areaCode: "0", id: "0" }],
      groupTabsValue: "all",
      //设备信息

      value: true,
      selectAreaCode: null,
      checkList: [],
      data: {},

      isDisable: false, //防止重复提交
      autoControlConfig: {
        irrigationTimeList: [
          {
            openTime: null,
            openDuration: null,
          },
        ],
      },
      isDisableControl: this.$route.query.isDisableControl,
    };
  },
  created: function () {
    this.checkList.push(this.$route.query.areaCode);
    //   this.data = this.RegionInfo;
    // alert(1);
    this.initTab();
    this.init();
  },
  mounted: function () {
    // alert(2);
    // this.init();
    // this.$nextTick(() => {
    //   this.init();
    // });
  },

  methods: {
    // 初始化
    initTab() {
      getEquipmentCode("waterEquipment").then((response) => {
        this.code = response.data;
        listEquipmentArea({ categoryCode: this.code, pageSize: 100 }).then(
          (response) => {
            this.groubTabs = [{ areaName: "全部", areaCode: "0", id: "0" }];
            response.data.forEach((element) => {
              this.groubTabs.push(element);
            });
          }
        );
      });
    },
    // 获取设备code
    init() {
      this.loading = true;

      listSprinklingIrrigationSetting({
        areaCode: this.$route.query.areaCode,
        pageSize: 100,
      }).then((response) => {
        if (response.rows.length > 0) {
          // this.data = response.rows[0];

          // this.data.openTime = response.rows[0].openTime;
          //this.data.autoCheck.push(this.data.autoControl);
          this.autoControlConfig.irrigationTimeList = response.rows;
        }

        this.loading = false;
      });
    },
    //新增自动控制时间
    addRow() {
      const that = this;
      that.autoControlConfig.irrigationTimeList.push({});
    },
    //删除自动控制时间
    removeRow(index) {
      if (index >= 0) {
        this.autoControlConfig.irrigationTimeList.splice(index, 1);
      }
    },

    // 查询
    handleClick(tab, event) {
      console.log(tab, event);
      this.selectAreaCode = tab.name;
    },
    OnCancel() {
      this.$router.push({
        path: "/plugin/irrigation/UI/IrrigationControl",
        query: {
          areaCode: this.$route.query.areaCode,
        },
      });
      //this.$router.go(-1); //返回上一层
    },
    changeCheck(val) {
      if (this.data.autoCheck.length > 1) {
        this.data.autoCheck.splice(0, 1);
        console.log("checkval", this.data.autoCheck, this.data.autoCheck);
      }
    },
    OnConfirm(formName) {
      this.isDisable = true;
      const that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //  this.data.closeTime = Date.parse(this.data.closeTime);
          //  this.data.openTime = Date.parse(this.data.openTime);
          this.data.areaCode = this.$route.query.areaCode;
          this.data.list = this.autoControlConfig.irrigationTimeList;
          this.data.list.forEach((item) => {
            item.areaCode = this.data.areaCode;
            item.status = this.$route.query.autoControl ? "1" : "2";
          });

          if (this.data.id != null) {
            updateSprinklingIrrigationSetting(this.data)
              .then((response) => {
                this.isDisable = false;

                this.$message({
                  type: "success",
                  message: "修改成功",
                });
                this.OnCancel();
              })
              .catch((err) => {
                this.isDisable = false;
              });
          } else {
            batchUpdateSprinklingIrrigationSetting(this.data)
              .then((response) => {
                this.isDisable = false;
                this.$message({
                  type: "success",
                  message: "增加成功",
                });
                this.OnCancel();
              })
              .catch((err) => {
                this.isDisable = false;
              });
          }
        } else {
          this.isDisable = false;
          return false;
        }
      });
    },
  },
};
</script>

<style lang="css" scoped>
</style>>


